import { Utils } from './../underscore-extensions';
import directives from './module';
import { AuthenticationSvc } from '../services/AuthenticationSvc';

const getLoginState = () =>
    Utils.getProduct() === 'WAVE' ? 'login' : 'studio-login';

export const handlerClickLogin = (
    state: ng.ui.IStateService,
    AuthenticationSvc: AuthenticationSvc
) => () =>
    options.handHeld
        ? state.go(getLoginState())
        : AuthenticationSvc.toggleLoginModal();

export const handlerClickSignUp = (productName: AnimatronProduct) => () => {
    const redirectAfterSignUpUrls = ['workshops', 'tutorial'];
    const isRedirectUrl = redirectAfterSignUpUrls.includes(
        location.pathname.replace('/', '')
    );
    const redirectParam = isRedirectUrl ? `?redirectUrl=${location.href}` : '';

    return Utils.redirectToReact(`signup${redirectParam}`, productName);
};

export const canShowLoginButton = (state: ng.ui.IStateService) => () =>
    !(state.is('login') || state.is('studio-login'));

class StudioHeader implements ng.IComponentController {
    handlerClickLogin = handlerClickLogin(this.$state, this.AuthenticationSvc);
    handlerClickSignUp = handlerClickSignUp('STUDIO');
    canShowLoginButton = canShowLoginButton(this.$state);

    constructor(
        private $state: ng.ui.IStateService,
        public AuthenticationSvc: AuthenticationSvc
    ) {}
}

directives.component('studioHeader', {
    controller: StudioHeader,
    templateUrl: require('studio-header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/studioHeader.ts